<template>
  <OwnScrollContainer v-if="scroll">
    <div class="dialog-content">
      <slot />
    </div>
  </OwnScrollContainer>

  <div v-else class="dialog-content">
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { OwnScrollContainer } from '../OwnScrollContainer'

withDefaults(defineProps<{ scroll?: boolean }>(), {
  scroll: false,
})
</script>

<style lang="scss" scoped>
.dialog-content {
  padding: 32px 24px;
}
</style>
